module.exports = __webpack_public_path__ + "img/job_itinerary_2.60db4e06.png";